// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
'use strict'
import { PFixFieldSet } from '../Fields/FieldsImport.js'
import { FieldsFactory } from '../Factory/FieldsFactory.js'
var SourceGroup = function (pfixFieldSet)
{
    PFixFieldSet.call(this, FieldsFactory.SOURCE_GROUP, null, pfixFieldSet)
}

SourceGroup.prototype = Object.create(PFixFieldSet.prototype)

SourceGroup.prototype.getSource = function ()
{
    return this.GetValue(FieldsFactory.FIELD_SOURCE) || ''
}

SourceGroup.prototype.getSourceId = function ()
{
    return this.GetValue(FieldsFactory.FIELD_SOURCE_ID) || 0
}

SourceGroup.prototype.getExternalSourceId = function ()
{
    return this.GetValue(FieldsFactory.FIELD_SOURCE_EXT_ID) || ''
}

export { SourceGroup }